export default "__VITE_ASSET__ORkiC1bH__"